import React from "react";

export const Privacypolicy = (props) => {
    return (
        <div id='policy' style={{ textAlign: 'justify' }} >

            <div className="solution">
                <div className="container">
                    <a href="/">Back To Home</a>
                    <div className="row">

                        <div className="col-md-7">
                            <div className="filter">
                                <div className="filter-img"><img src="img/wedo/drinkingwater.png" className="img-fluid" alt="ro repair water purifier" /></div>

                            </div>
                        </div>

                        <div className="col-md-5">
                            <h3>Privacy Policy</h3>
                            Thank you for choosing Aryan Enterprises for your RO repair and maintenance needs. We value your trust and are committed to protecting your personal information.<br />
                            This Privacy Policy describes how we collect, use, disclose, and safeguard your data when you visit our website <a href="mailto: waterpurifierservices.info@gmail.com ">www.aryan-enterprises.co.in</a> or any related media platforms, including mobile sites or applications (collectively referred to as the “Site”).
                            Please take a moment to read this policy carefully.<b><br /> If you do not agree with any part of this Privacy Policy, please discontinue use of our Site.</b>
                            <br /><br />
                            <a href="/">Back To Home</a>
                        </div>

                    </div>

                </div>

            </div>
            <div className="rorepair">
                <div className="container">
                    1. Information We Collect<br />

                    We may collect information about you in a variety of ways. The information we may collect on the Site includes:

                    Personal Data:
                    Name
                    Address
                    Email address
                    Phone number
                    Payment information (such as credit card details)
                    Any other information voluntarily provided by you

                    Non-Personal Data:
                    Browser type
                    Demographic information
                    IP address
                    Operating system used

                    <br /><br />
                    2. How We Use Your Information<br />

                    We use the information we collect in the following ways:<br />
                    <ul>
                        <li><b>Fulfilling Service Requests:</b> Managing, processing, and completing your orders for RO services.</li>

                        <li><b>Enhancing Your Experience:</b> Continuously refining and improving our products, services, and overall user experience.</li>

                        <li><b>Providing Updates & Offers:</b> Sending promotional messages, updates on new products, special deals, and other content we believe may interest you, using the email address you provided.</li>

                        <li><b>Conducting Research:</b> Reaching out for surveys or feedback to better understand your needs and preferences.</li>

                        <li><b>Personalizing Your Visit:</b> Tailoring the website’s content, layout, and features to better align with your interests and browsing behavior.</li>
                    </ul>
                    <br />
                    3. Disclosure of Your Information

                    We may disclose your information to third parties only as outlined in this privacy statement. These circumstances include:
                    <br />
                    <ul>
                        <li><b><u>Third-Party Service Providers:</u></b> We may provide your information to trusted vendors, consultants, and service providers who assist us in operating our business or delivering services on our behalf.</li>

                        <li><b><u>Business Transitions:</u></b> Your information may be shared or transferred as part of, or during discussions related to, a merger, sale of assets, financing arrangement, or acquisition of all or part of our business by another entity.</li>

                        <li><b><u>Legal Obligations:</u></b> We may release your information when required to comply with applicable laws, government directives, court orders, judicial proceedings, or other legal processes.</li>
                    </ul>
                    <br />
                    4. Security of Your Information

                    We use administrative, technical, and physical security measures to help protect your personal information. While we have taken reasonable steps to secure the personal information you provide to us, please be aware that despite our efforts, no security measures are perfect or impenetrable, and no method of data transmission can be guaranteed against any interception or other type of misuse.
                    <br /><br />
                    5. Changes to This Privacy Policy

                    We may update this Privacy Policy from time to time in order to reflect, for example, changes to our practices or for other operational, legal, or regulatory reasons.
                    <br /><br />
                    6. Contact Us

                    If you have any questions about this Privacy Policy, please contact us at:

                    Aryan Enterprises
                    Phone: 91622 81169
                </div>
            </div>

        </div>
    )
}